import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Popover,
  Row,
  PageHeader,
} from 'antd';
import PropTypes from 'prop-types';
import TableFilterDropdown from '../../../common/tables/TableFilterDropdown';


import OnTraccrButton from '../../../common/buttons/OnTraccrButton';

export default function SelectLabelFilter({
  style = {},
  selected = [],
  onSelectedChanged,
  type,
  disabled = false,
}) {
  const labels = useSelector((state) => state.labels);
  const [visible, setVisible] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState(selected);
  const filters = useMemo(
    () => labels
      .filter((l) => l.type === type)
      .map((l) => ({ text: l.title, value: l.id })),
    [labels],
  );
  const clearFilters = () => setSelectedKeys([]);
  const confirm = () => {
    onSelectedChanged(selectedKeys);
    setVisible(false);
  };
  const dropdown = (
    <>
      <Row>
        <PageHeader
          title="Filter by Label"
          style={{ padding: 0, marginBottom: 5, fontFamily: 'raleway-medium' }}
        />
      </Row>

      <TableFilterDropdown
        visible={visible}
        filters={filters}
        selectedKeys={selectedKeys}
        setSelectedKeys={setSelectedKeys}
        clearFilters={clearFilters}
        confirm={confirm}
      />
    </>
  );
  return (
    <div className="form-user-selector-filter">
      <Popover
        trigger={!disabled ? 'click' : ''}
        placement="topRight"
        content={dropdown}
        visible={visible}
        onVisibleChange={(v) => setVisible(v)}
      >
        <OnTraccrButton
          title="Filter"
          type={selected.length ? 'back' : 'primary'}
          style={style}
          disabled={disabled}
        />
      </Popover>
    </div>
  );
}

SelectLabelFilter.propTypes = {
  disabled: PropTypes.bool,
};

SelectLabelFilter.defaultProps = {
  disabled: false,
};
